export function TutorCardSkeleton() {
  return (
    <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/60 p-5 shadow-sm animate-pulse space-y-4">
      <div className="flex gap-4 items-start">
        <div className="h-16 w-16 rounded-full bg-slate-200 dark:bg-slate-800 shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-1/3" />
          <div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-2/3" />
          <div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-1/2" />
        </div>
        <div className="h-6 bg-slate-200 dark:bg-slate-800 rounded w-12" />
      </div>
      <div className="flex flex-wrap gap-2 pt-1">
        <div className="h-5 bg-slate-200 dark:bg-slate-800 rounded-full w-16" />
        <div className="h-5 bg-slate-200 dark:bg-slate-800 rounded-full w-20" />
      </div>
      <div className="flex justify-between items-center pt-3 border-t border-slate-100 dark:border-slate-800">
        <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-20" />
        <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded-lg w-24" />
      </div>
    </div>
  );
}
